import { ACHIEVEMENT_GROUPS, computeAchievements } from "../constants/achievements";

export default function AchievementBadges({ streak, history }) {
  const { unlocked } = computeAchievements(streak, history);
  const unlockedIds = new Set(unlocked.map(a => a.id));
  const total = ACHIEVEMENT_GROUPS.reduce((s, g) => s + g.items.length, 0);

  return (
    <div className="card" style={{ marginBottom: "20px" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <div style={{ fontSize: "14px", fontWeight: "600", color: "var(--text-primary)" }}>
          Thành Tích
        </div>
        <div style={{ fontSize: "12px", color: "var(--text-muted)" }}>
          {unlocked.length}/{total}
        </div>
      </div>

      {/* Progress bar */}
      <div style={{
        background: "var(--bg-inset)", borderRadius: "8px", height: "6px",
        overflow: "hidden", marginBottom: "20px",
      }}>
        <div style={{
          height: "100%", borderRadius: "8px",
          background: "linear-gradient(90deg, #10B981, #3B82F6)",
          width: `${(unlocked.length / total) * 100}%`,
          transition: "width 0.5s ease",
        }} />
      </div>

      {/* Achievement Groups */}
      {ACHIEVEMENT_GROUPS.map(group => {
        const groupUnlocked = group.items.filter(a => unlockedIds.has(a.id)).length;
        return (
          <div key={group.id} style={{ marginBottom: "20px" }}>
            {/* Group header */}
            <div style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              marginBottom: "10px",
            }}>
              <div style={{ fontSize: "12px", fontWeight: "600", color: group.color }}>
                {group.label}
              </div>
              <div style={{ fontSize: "10px", color: "var(--text-dim)" }}>
                {groupUnlocked}/{group.items.length}
              </div>
            </div>

            {/* Badges grid — all shown */}
            <div style={{
              display: "grid",
              gridTemplateColumns: `repeat(${Math.min(group.items.length, 4)}, 1fr)`,
              gap: "8px",
            }}>
              {group.items.map(ach => {
                const isUnlocked = unlockedIds.has(ach.id);
                return (
                  <div key={ach.id} style={{
                    background: isUnlocked ? "var(--bg-card-alt)" : "var(--bg-inset)",
                    borderRadius: "12px",
                    padding: "12px 6px",
                    textAlign: "center",
                    border: isUnlocked
                      ? `1px solid ${group.color}44`
                      : "1px solid var(--border-secondary)",
                    opacity: isUnlocked ? 1 : 0.45,
                    filter: isUnlocked ? "none" : "grayscale(1)",
                    transition: "all 0.3s ease",
                    position: "relative",
                  }}>
                    <div style={{ fontSize: "28px", marginBottom: "4px" }}>{ach.emoji}</div>
                    <div style={{
                      fontSize: "10px", fontWeight: "700",
                      color: isUnlocked ? "var(--text-primary)" : "var(--text-dim)",
                      lineHeight: 1.2,
                    }}>
                      {ach.title}
                    </div>
                    <div style={{
                      fontSize: "9px",
                      color: isUnlocked ? "var(--text-muted)" : "var(--text-dim)",
                      marginTop: "2px",
                    }}>
                      {ach.desc}
                    </div>
                    {/* Lock icon for locked badges */}
                    {!isUnlocked && (
                      <div style={{
                        position: "absolute", top: "4px", right: "4px",
                        fontSize: "10px", opacity: 0.5,
                      }}>🔒</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
